export const leaderboardCopy = {
  fr: {
    description: "Les contributeurs les plus actifs de la communauté.",
    descriptionCount: "{count} contributeurs classés, {scope}, {period}.",
    descriptionCountOne: "1 contributeur classé, {scope}, {period}.",
    scopeAll: "toutes langues confondues",
    scopeLanguage: "en {language}",
    counted: "Comptent : les audios enregistrés, les transcriptions écrites et les réponses aux questions.",
    filtersLabel: "Filtres du classement",
    languageLabel: "Langue",
    allLanguages: "Toutes les langues",
    periodLabel: "Période",
    periodWeek: "7 derniers jours",
    periodMonth: "30 derniers jours",
    periodAll: "Depuis le début",
    periodWeekShort: "sur 7 jours",
    periodMonthShort: "sur 30 jours",
    periodAllShort: "depuis le début",
    searchLabel: "Rechercher un contributeur",
    positionTitle: "Votre position",
    positionRank: "Rang",
    positionValue: "Contributions",
    positionOf: "sur {count}",
    positionLeader: "Vous êtes en tête du classement.",
    positionGap: "Encore {needed} contributions pour passer devant {name} (n° {rank}).",
    positionUnranked: "Vous n'apparaissez pas encore dans ce classement.",
    positionUnrankedHint: "Seuls les {count} premiers sont affichés. Chaque contribution vous rapproche.",
    contribute: "Contribuer",
    podiumLabel: "Les trois premiers",
    rankShort: "n° {rank}",
    you: "Vous",
    tableLabel: "Classement des contributeurs",
    rank: "Rang",
    contributor: "Contributeur",
    languagesCol: "Langues",
    value: "Contributions",
    pageOf: "Page {page} sur {pages}",
    perPage: "Par page",
    previous: "Page précédente",
    next: "Page suivante",
    emptyTitle: "Aucune contribution sur cette période",
    emptyHint: "Essayez une autre période ou une autre langue.",
    noResults: "Aucun contributeur ne correspond à « {query} ».",
    clearSearch: "Effacer la recherche",
    errorTitle: "Le classement n'a pas pu être chargé",
    errorHint: "Vérifiez votre connexion puis réessayez.",
    export: "Exporter en CSV",
    exporting: "Export…",
    exportError: "L'export a échoué",
  },
  en: {
    description: "The most active contributors of the community.",
    descriptionCount: "{count} ranked contributors, {scope}, {period}.",
    descriptionCountOne: "1 ranked contributor, {scope}, {period}.",
    scopeAll: "all languages",
    scopeLanguage: "in {language}",
    counted: "What counts: recorded audios, written transcriptions and answers to questions.",
    filtersLabel: "Leaderboard filters",
    languageLabel: "Language",
    allLanguages: "All languages",
    periodLabel: "Period",
    periodWeek: "Last 7 days",
    periodMonth: "Last 30 days",
    periodAll: "All time",
    periodWeekShort: "over 7 days",
    periodMonthShort: "over 30 days",
    periodAllShort: "all time",
    searchLabel: "Search a contributor",
    positionTitle: "Your position",
    positionRank: "Rank",
    positionValue: "Contributions",
    positionOf: "of {count}",
    positionLeader: "You lead the leaderboard.",
    positionGap: "{needed} more contributions to pass {name} (no. {rank}).",
    positionUnranked: "You are not on this leaderboard yet.",
    positionUnrankedHint: "Only the top {count} are shown. Every contribution brings you closer.",
    contribute: "Contribute",
    podiumLabel: "Top three",
    rankShort: "no. {rank}",
    you: "You",
    tableLabel: "Contributors leaderboard",
    rank: "Rank",
    contributor: "Contributor",
    languagesCol: "Languages",
    value: "Contributions",
    pageOf: "Page {page} of {pages}",
    perPage: "Per page",
    previous: "Previous page",
    next: "Next page",
    emptyTitle: "No contribution in this period",
    emptyHint: "Try another period or another language.",
    noResults: "No contributor matches \"{query}\".",
    clearSearch: "Clear search",
    errorTitle: "The leaderboard could not be loaded",
    errorHint: "Check your connection and try again.",
    export: "Export as CSV",
    exporting: "Exporting…",
    exportError: "The export failed",
  },
} as const;

export type LeaderboardCopy = { [K in keyof (typeof leaderboardCopy)["fr"]]: string };

export const fill = (text: string, values: Record<string, string | number>) =>
  Object.entries(values).reduce((out, [key, value]) => out.split(`{${key}}`).join(String(value)), text);
